<template>
  <v-card class="back" style="height: 700px">

        <v-layout column fill-height>
          <scroll-area>
            <template slot="header">
              <v-toolbar dark color="secondary" dense flat>
                <v-toolbar-title>
                  <span v-if="addMode" class="body-2 text-uppercase">{{$t('add new user')}}</span>
                  <span v-if="!addMode && getData.name" class="body-2 text-uppercase">{{ getData.name }}</span>
                </v-toolbar-title>

                <v-layout  justify-end>
                  <v-tooltip dark color="secondary" bottom>
                    <v-btn icon flat slot="activator" 
                    :data-testid="$options.name + '__btn__' + 'close'"
                    @click="()=>{$emit('close')}">
                      <svg-icon
                        :color="'white'"
                        :name="'close'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('close') }}</span>
                  </v-tooltip>
                </v-layout>

              </v-toolbar>             
            </template>

            <template slot="body">
              <v-layout column  justify-start class="pa-1">
                <v-form ref="user_card_form">
                  <v-layout shrink align-center  pb-1>
                    
                    <v-flex xs4 shrink px-0 >
                      <v-text-field
                        :value="$t('type_auth')"
                        light
                        outline
                        readonly
                        disabled
                        class="backgrey"
                        hide-details                    
                        :rows="1"
                        color="white"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs8 shrink px-0 >
                      <v-select
                        :data-testid="$options.name + '__select__' + 'type_auth'"
                        v-model="model.obj.type_auth"
                        light
                        :items="getAuthTypes"
                        outline
                        hide-details
                        class="white"
                        background-color="backgrey"
                        clearable
                      >
                      </v-select>

                    </v-flex>
                  
                  </v-layout>

                  <v-layout shrink v-if="showADFields" align-center  pb-1>
                    
                    <v-flex xs4 shrink px-0 >
                      <v-text-field
                        :value="$t('group')"
                        light
                        outline
                        readonly
                        disabled
                        class="backgrey"
                        hide-details                    
                        :rows="1"
                        color="white"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex  px-0 >
                      <v-select
                        :data-testid="$options.name + '__select__' + 'group'"
                        v-model="ADFilter.cn"
                        light
                        :items="getADGroups"
                        outline
                        hide-details
                        class="white"
                        background-color="backgrey"
                        clearable
                      >
                      </v-select>

                    </v-flex>

                    <v-btn :data-testid="$options.name + 'v-btn' + 'getADUsers'" dark small @click="()=>getADUsers()" color="success">{{$t('seeking')}}</v-btn>
                  
                  </v-layout>

                  <v-layout shrink v-if="getUsers.length"  pb-1>

                    <v-flex xs4 shrink px-0 >
                      <v-text-field
                        :value="$t('users LDAP')"
                        light
                        outline
                        readonly
                        disabled
                        class="backgrey"
                        hide-details                    
                        :rows="1"
                        color="white"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs8 shrink px-0 >

                      <v-select
                        :data-testid="$options.name + '__select__' + 'users_LDAP'"
                        v-model="ADUser"
                        light
                        required
                        :items="getUsers"
                        :item-text="getFieldName('name')"
                        :item-value="getFieldName('name')"
                        return-object
                        outline
                        hide-details
                        class="white"
                        background-color="backgrey"
                        clearable
                      >
                      </v-select>

                    </v-flex>
                  
                  </v-layout>

                  <v-layout shrink v-for="(field, index) in getFields" :key="index" v-if="field.show == 'true'" >
                    <v-flex xs4 shrink v-if="field.name != 'push_active' && field.name != 'password' && field.type != 'boolean'" px-0 pb-1>
                      <v-text-field
                        :value="$t(field.name)"
                        light
                        outline
                        readonly
                        disabled
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs4 shrink v-if="field.name == 'password' && !showADFields" px-0 pb-1>
                      <v-text-field
                        :value="$t(field.name)"
                        light
                        outline
                        readonly
                        disabled
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >
                      </v-text-field>
                    </v-flex>
                    
                    <v-flex xs8 shrink px-0>

                      <v-tooltip v-if="getDescriptions[field]" dark color="secondary" bottom>

                        <v-text-field
                          v-if="field.type == 'integer'"
                          slot="activator"
                          :data-testid="$options.name + '__text-field__' + field.name"
                          v-model.number="model.obj[field.name]"
                          :type="'number'"
                          light
                          outline
                          class="white"
                          hide-details                     
                          :rows="1"
                          color="accent"
                        >
                        </v-text-field>

                        <v-text-field
                          v-else
                          slot="activator"
                          :data-testid="$options.name + '__text-field__' + field.name"
                          v-model="model.obj[field.name]"
                          light
                          outline
                          class="white"
                          hide-details                     
                          :rows="1"
                          color="accent"
                        >
                        </v-text-field>
                        <span >{{ $t(getDescriptions[field.name]) }}</span>
                      </v-tooltip>

                      <v-text-field
                        v-if="!getDescriptions[field.name] && field.type == 'integer'"
                        :data-testid="$options.name + '__text-field__' + field.name"
                        v-model.number="model.obj[field.name]"
                        :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                        :required="model.fields[field.name].required"
                        :type="'number'"
                        light
                        outline
                        class="white"
                        hide-details                     
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>
                      
                      <v-text-field
                        v-if="!getDescriptions[field.name] && field.type == 'text' && field.name != 'password' && field.name != 'push_active'"
                        :data-testid="$options.name + '__text-field__' + field.name"
                        v-model="model.obj[field.name]"
                        :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                        :required="model.fields[field.name].required"
                        light
                        outline
                        :disabled="showADFields && !ADUser && field.name == 'name'"
                        :readonly="!!ADUser && field.name == 'name'"
                        class="white"
                        hide-details                     
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>

                      <v-text-field
                        v-if="!showADFields && !getDescriptions[field.name] && field.type == 'text' && field.name == 'password'"
                        :data-testid="$options.name + '__text-field__' + field.name"
                        v-model="model.obj[field.name]"
                        light
                        :type="visible ? 'text' : 'password'"
                        @click:append="() => (visible = !visible)"
                        :append-icon="visible ? 'visibility' : 'visibility_off'"
                        :rules="showADFields ? [v => !!v || $t('required')] : []"
                        required
                        outline
                        class="white"
                        hide-details                     
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>

                      <v-select
                        v-if="(field.type == 'select' || field.type == 'select_enum') && field.name != 'roles'"
                        :data-testid="$options.name + '__select__' + field.name"
                        v-model="model.obj[field.name]"
                        light
                        :rules="model.fields[field.name] && model.fields[field.name].required ? [value => !!value || $t('required')] : []"
                        required
                        :items="getItems[field.cls]"
                        :item-text="field.type == 'select' ? 'name' : 'value'"
                        :item-value="field.type == 'select' ? '$id' : 'id'"
                        outline
                        hide-details
                        class="white"
                        background-color="backgrey"
                      >
                        <template v-slot:item="{ item, index }">
                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                        </template>
                      </v-select>

                      <v-select
                        v-if="(field.type == 'select' || field.type == 'select_enum') && field.name == 'roles'"
                        :data-testid="$options.name + '__select__' + field.name"
                        v-model="model.obj[field.name].role_nms"
                        light
                        
                        required
                        :items="getItems[field.cls]"
                        :item-text="field.type == 'select' ? 'name' : 'value'"
                        :item-value="field.type == 'select' ? '$id' : 'id'"
                        outline
                        hide-details
                        class="white"
                        background-color="backgrey"
                      >
                        <template v-slot:item="{ item, index }">
                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                        </template>
                      </v-select>

                      <!-- <v-checkbox
                        small
                        light
                        color="secondary"
                        v-if="field.type == 'boolean' || field.name == 'push_active'"
                        :data-testid="$options.name + '__checkbox__' + field.name"
                        v-model="model.obj[field.name]"
                      >
                        <template v-slot:label>
                          <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                          <span class="black--text" v-else>{{$t(field.name)}}</span>
                        </template>
                      </v-checkbox> -->

                    </v-flex>

                  </v-layout>

                  
                  <v-layout v-if="model.obj.is_blocked" style="height: 70px" align-center>
                    <v-flex xs2 shrink px-0 pb-1>
                      <v-checkbox
                        small
                        light
                        color="secondary"
                        :data-testid="$options.name + '__checkbox__' + 'is_blocked.active'"
                        v-model="model.obj.is_blocked.active"
                      >
                        <template v-slot:label>
                          <span class="black--text">{{$t('is_blocked')}}</span>
                        </template>
                      </v-checkbox>
                    </v-flex>

                    <v-layout shrink align-baseline v-show="model.obj.is_blocked.active">
                      <v-flex shrink pr-3 pb-1>
                        <date-picker
                          :value="model.obj.is_blocked.exc"
                          :label="$t('Дата окончания блокировки')"
                          @dateChange="(payload) => dateMethod('endRT', payload)"
                        />
                      </v-flex>

                      <v-flex xs3>
                        <time-selector
                          :value="blocked_time"
                          @change="(payload) => timeMethod('endRT', payload)"
                        />
                      </v-flex>
                    </v-layout>
                  </v-layout>




                  <v-layout v-if="model.obj.notification?.mail" shrink align-center>
                    
                    <v-flex xs4 shrink px-0 pb-1>
                      <v-checkbox
                        small
                        light
                        color="secondary"
                        :data-testid="$options.name + '__checkbox__' + 'e-mail notification'"
                        v-model="model.obj.notification.mail.active"
                      >
                        <template v-slot:label>
                          <span class="black--text">{{$t('Уведомления по e-mail')}}</span>
                        </template>
                      </v-checkbox>
                    </v-flex>

                    <v-layout shrink-- align-baseline v-show="model.obj.notification.mail.active">
                      <v-flex xs4 shrink px-0 pb-1>
                        <v-text-field
                          :value="$t('адрес почты')"
                          light
                          outline
                          readonly
                          disabled
                          class="backgrey"
                          hide-details
                          :rows="1"
                          color="white"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs8 shrink px-0 pb-1>
                        <v-text-field
                          slot="activator"
                          :data-testid="$options.name + '__text-field__' + 'e-mail address'"
                          v-model="model.obj.notification.mail.mail"
                          light
                          outline
                          class="white"
                          hide-details                     
                          :rows="1"
                          color="accent"
                        >
                        </v-text-field>
                      </v-flex>    
                    </v-layout>

                  </v-layout>
                  
                  <v-layout v-if="model.obj.notification?.sms" shrink align-center>
                    
                    <v-flex xs4 shrink px-0 pb-1>
                      <v-checkbox
                        small
                        light
                        color="secondary"
                        :data-testid="$options.name + '__checkbox__' + 'sms notification'"
                        v-model="model.obj.notification.sms.active"
                      >
                        <template v-slot:label>
                          <span class="black--text">{{$t('смс уведомления')}}</span>
                        </template>
                      </v-checkbox>
                    </v-flex>

                    <v-layout shrink-- align-baseline v-show="model.obj.notification.sms.active">
                      <v-flex xs4 shrink px-0 pb-1>
                        <v-text-field
                          :value="$t('номер для смс')"
                          light
                          outline
                          readonly
                          disabled
                          class="backgrey"
                          hide-details
                          :rows="1"
                          color="white"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs8 shrink px-0 pb-1>
                        <v-text-field
                          slot="activator"
                          :data-testid="$options.name + '__text-field__' + 'sms phone'"
                          v-model="model.obj.notification.sms.phone"
                          light
                          outline
                          class="white"
                          hide-details                     
                          :rows="1"
                          color="accent"
                        >
                        </v-text-field>
                      </v-flex>  
                    </v-layout>

                  </v-layout>

                  <v-layout v-if="model.obj.notification?.push" shrink align-center>
                    
                    <v-flex xs4 shrink px-0 pb-1>
                      <v-checkbox
                        small
                        light
                        color="secondary"
                        :data-testid="$options.name + '__checkbox__' + 'push notification'"
                        v-model="model.obj.notification.push.active"
                      >
                        <template v-slot:label>
                          <span class="black--text">{{$t('push уведомления')}}</span>
                        </template>
                      </v-checkbox>
                    </v-flex>

                  </v-layout>

                  
                </v-form>
              </v-layout>
            </template>

            <template slot="footer">
              <v-layout fill-height>
                <v-layout fill-height justify-start>
                  <v-btn v-if="addMode" dark small :data-testid="$options.name + '__btn__' + 'createData'" @click="()=>createData()" color="success">{{$t('add')}}</v-btn>
                  <v-btn v-if="!addMode" dark small :data-testid="$options.name + '__btn__' + 'saveData'" @click="()=>saveData()" color="success">{{$t('save')}}</v-btn>
                  <v-btn v-if="!addMode"dark small :data-testid="$options.name + '__btn__' + 'removeItem'" @click="()=>removeItem()" color="secondary">{{$t('remove')}}</v-btn>
                  <v-btn v-if="!addMode && getData.user_id" dark small :data-testid="$options.name + '__btn__' + 'resetPass'" @click="()=>resetPass()" color="red">{{$t('reset password')}}</v-btn>
                </v-layout>
                <v-layout fill-height justify-end>
                  <v-btn dark small :data-testid="$options.name + '__btn__' + 'close'" @click="()=>{$emit('close')}" color="secondary">{{$t('close')}}</v-btn>                 
                </v-layout>
              </v-layout>
            </template>

          </scroll-area>
        </v-layout>

  </v-card>
</template>

<script lang="ts">
import Vue from 'vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import userMeta from '@/nms/pages/configuration/components/user_meta.js'
import datePicker from '@/nms/components/controls/input-menu-datepicker.vue'
import timeSelector from '@/nms/components/controls/time-selector.vue'
import { CCMDBObject } from '@entcor/ebridge'

// Типы
interface ADFilter {
  cn: string | null
  displayName: string | null
  mail: string | null
  sAMAccountName: string | null
}

interface ADUser {
  cn?: string
  displayName?: string
  mail?: string
  sAMAccountName?: string
  name?: string
  email?: string
  sms_phone?: string
  [key: string]: any
}

interface ModelData {
  fields: Record<string, any>
  obj: Record<string, any>
  items: Record<string, any>
  refs: Record<string, any>
}

interface LdapData {
  base_dn?: string
  [key: string]: any
}

interface MetaData {
  [key: string]: any
}

interface UserData {
  user_id?: string
  name?: string
  [key: string]: any
}

interface DescriptionsData {
  [key: string]: any
}

export default Vue.extend({
  name: 'USER_CARD',

  components: {
    loadingCircle,
    scrollTable,
    scrollArea,
    datePicker,
    timeSelector,
    svgIcon
  },

  props: {
    data: {
      type: Object as () => UserData,
      default: () => ({})
    },
    addMode: {
      type: Boolean,
      default: () => false
    },
    descriptions: {
      type: Object as () => DescriptionsData,
      default: () => ({})
    },
  },

  data(): {
    typeAuth: string
    showADFields: boolean
    ADGroups: string[]
    ADFilter: ADFilter
    users: ADUser[]
    ADUser: ADUser | null
    err: string
    meta: MetaData | null
    model: ModelData
    visible: boolean
    ldap: LdapData | null
  } {
    return {
      typeAuth: 'local',
      showADFields: false,
      ADGroups: [],
      ADFilter: {
        cn: null,
        displayName: null,
        mail: null,
        sAMAccountName: null,
      },
      users: [],
      ADUser: null,
      err: '',
      meta: null,
      model: {
        fields: {},
        obj: {
          type_auth: 'local',
          roles: {
            role_enode: null,
            role_nms: null,
          },
          is_blocked: {
            active: false,
            exc: null,
          },
          notification: {
            mail: {
              active: false,
              mail: null
            },
            push: {
              active: false,
            },
            sms: {
              active: false,
              phone: null
            },
          },
        },
        items: {},
        refs: {},
      },
      blocked_time: '',
      visible: false,
      ldap: null,
    }
  },

  computed: {
    getData(): UserData {
      return this.data
    },
    getFields(): Record<string, any> {
      return this.model.fields
    },
    getItems(): Record<string, any> {
      return this.model.items
    },
    getUsers(): ADUser[] {
      return this.users
    },
    getADGroups(): string[] {
      return this.ADGroups
    },
    getDescriptions(): DescriptionsData {
      return this.descriptions
    },
    getAuthTypes(): string[] {
      if (this.ADGroups.length) {
        return ['local', 'LDAP', 'keycloak']
      }
      return ['local', 'keycloak']
    },
  },

  watch: {
    typeAuth(newVal: string): void {
      if (newVal) {
        this.showADFields = newVal === 'LDAP'
      } else {
        this.showADFields = false
      }
    },

    ADUser(val: ADUser | null): void {
      // console.log('WATCH', this.$options.name, 'ADUSER val', val )
      if (val) {
        this.prepareADData()
      } else {
        this.prepareData()
      }
    },

    showADFields(val: boolean): void {
      // console.log('WATCH', this.$options.name, 'showADFields val', val )
      if (val) {
        this.prepareADData()
      } else {
        this.setup()
      }
    },

    'model.obj.roles.role_nms'(val: string): void {
      // console.log('WATCH', this.$options.name, 'model.obj.roles.role_nms val', val )
      if (val) {
        this.$set(this.model.obj.roles, 'role_enode', val == 'administrator' ? 'admin' : 'user')
      }
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      this.reset()
      this.loadMeta()
    },

    async getADUsers(): Promise<void> {
      try {
        let filter: any = { objectClass: ['user'] }
        if (this.ADFilter.cn && this.ldap?.base_dn) {
          const memberOf = [`CN=${this.ADFilter.cn},${this.ldap.base_dn}`]
          filter = { objectClass: ['user'], memberOf }
        }
        const users = await this.$bridge.customQuery('alarm', 'auth/adusers', { filter }, 'post') as { data?: ADUser[] }
        if (users?.data) {
          this.users = users.data
        }
        console.log(this.$options.name, 'getADUsers', 'this.users', this.users)
      } catch (error) {
        console.log(this.$options.name, 'getADUsers', 'SMTH WRONG', error)
      }
    },

    async loadMeta(): Promise<void> {
      // this.meta = await this.$loadMeta('systemuser')
      this.meta = userMeta
      console.log('this.meta', this.meta)
      if (this.meta) {
        let model = await this.$prepareMeta(this.meta, this.$options.name)
        Object.keys(model).forEach(key => {
          model[key] = {...this.model[key], ...model[key]}
        })
        this.model = model
        this.users = []
        this.ADUser = null
        if (!this.addMode) {
          this.prepareData()
        }
      }
      // console.log(this.$options.name, '$prepareMeta', 'meta', this.meta)
      // console.log(this.$options.name, '$prepareMeta', 'this.model', this.model)
      await this.loadLDAPData()
      if (this.addMode) {
        this.loadADGroups()
      }
    },

    async loadADGroups(): Promise<void> {
      try {
        const ADGroups = await this.$bridge.customQuery('alarm', 'auth/adusers', { filter: { objectCategory: ['group'] } }, 'post') as { data?: Array<{ sAMAccountName?: string }> }
        if (ADGroups?.data && Array.isArray(ADGroups.data)) {
          ADGroups.data.forEach(obj => {
            if (obj.sAMAccountName) {
              this.ADGroups.push(obj.sAMAccountName)
            }
          })
        }
      } catch (error) {
        console.log(this.$options.name, 'loadADGroups', 'SMTH WRONG', error)
        this.$dialog.notify.error('Ошибка подключения к LDAP', { timeout: 3000 })
      }
    },

    async loadLDAPData(): Promise<void> {
      const objects = await this.$bridge.getObjectsByClass('ldap')
      this.ldap = objects?.[0] || null
    },

    getFieldName(val: string): string {
      if (!val) return val
      switch (val) {
        case 'name':
          return 'sAMAccountName'
        case 'email':
          return 'mail'
        case 'sms_phone':
          return 'telephoneNumber'
        default:
          return val
      }
    },

    async prepareADData(): Promise<void> {
      
      if (!this.ADUser) return
      // console.log(this.$options.name, 'prepareADData', 'this.ADUser', this.ADUser)
      // console.log(this.$options.name, 'prepareADData', 'this.getData', this.getData)
      Object.keys(this.model.fields).forEach($key => {
        const key = this.getFieldName($key)
        // console.log(this.$options.name, 'prepareADData', 'key', key)
        if (this.ADUser?.[key]) {
          const value = this.ADUser[key]
          this.$set(this.model.fields[$key], 'value', value)
          if (value === 'false') {
            this.$set(this.model.fields[$key], 'value', false)
          }
          if (value === 'true') {
            this.$set(this.model.fields[$key], 'value', true)
          }
        }

        if (key === 'sAMAccountName') {
          // console.log(this.$options.name, 'prepareADData', 'name!!!', key)
          this.$set(this.model.fields.name, 'value', this.ADUser[key])
          this.$set(this.model.obj, 'name', this.ADUser[key])
        }

        if ($key !== 'password') {
          // this.$set(this.model.obj, $key, this.ADUser?.[key])
          const value = this.ADUser?.[key]
          if (value === 'false') {
            this.$set(this.model.obj, key, false)
          }
          if (value === 'true') {
            this.$set(this.model.obj, key, true)
          }
        }

        if ($key === 'type_auth') {
          this.$set(this.model.fields[$key], 'value', this.showADFields ? 'AD' : 'local')
          this.$set(this.model.obj, $key, this.showADFields ? 'AD' : 'local')
        }
      })
      console.log('prepareADData MODEL', this.model)
    },

    async prepareData(obj?: any): Promise<void> {
      try {
        // const model = await this.$prepareData(this.model, this.getData, this.meta, this.$options.name)
        let r_ = JSON.parse(JSON.stringify(this.getData))
        // console.log(this.$options.name, 'prepareData', 'JSON', r_)
        // console.log(this.$options.name, 'prepareData', 'this.getData', this.getData)
        // console.log(this.$options.name, 'prepareData', 'this.model', this.model)
        const fields = Object.keys(this.model.fields)
        fields.forEach(name => {
          if(typeof this.getData[name] == 'string' && !this.getData[name].length) {
            if(name == 'data') {
              Vue.set(this.model.obj, name, {}) //в e-core нет метаданных, а поле data не обрабатывается пользователем, но ожидает пустой объект
            }
            else {
              Vue.set(this.model.obj, name, null) //с переходом на e-core сломалась нормальная валидация пустых строк. Вместо пустых строк нужно возвращать null
            }      
          }
          else {
            Vue.set(this.model.obj, name, this.getData[name])
          }
          Vue.set(this.model.fields[name], 'value', this.getData[name])
            // Vue.set(this.model.obj, name, this.getData[name]) 

          if (name === 'name' && this.getData.hasOwnProperty('full_name')) {
            Vue.set(this.model.fields[name], 'value', this.getData.full_name)
          }
          if (this.getData[name] === 'false') {
            Vue.set(this.model.obj, name, false)
          }
          if (this.getData[name] === 'true') {
            Vue.set(this.model.obj, name, true)
          }
        })
        
        if(this.getData?.notification) {
          Object.keys(this.getData.notification).forEach(key => {
            this.model.obj.notification[key] = this.getData.notification[key]
          })
        }
        if(this.getData?.roles?.role_nms) {
          Vue.set(this.model.fields.roles, 'value', this.getData.roles.role_nms)
          Vue.set(this.model.obj, 'roles', this.getData.roles)
        }
        if(this.getData?.is_blocked?.exc) {
          // console.log(this.$options.name, 'prepareData', 'is_blocked', this.getData.is_blocked.exc)
          if (this.getData.is_blocked.exc instanceof Date) {
            this.blocked_time = this.getData.is_blocked.exc.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
          }
        }
        // console.log(this.$options.name, 'prepareData', 'this.model', this.model)
      } catch (error) {
        this.setLoader('loadMeta', false)
      }
    },

    dateMethod(mode: string, val: string): void {
      // console.log(this.$options.name, 'dateMethod', 'val', val)
      if(val) {
        this.$set(this.model.obj.is_blocked, 'exc', new Date(val))
      }
    },

    timeMethod(mode: string, val: string): void {
      const hours = val.slice(0, 2)
      const minutes = val.slice(-2)
      const date$ = this.model.obj.is_blocked.exc
      // console.log('time method date before', JSON.parse(JSON.stringify(date$)))
      if (date$ && typeof date$ === 'object' && date$ instanceof Date) {
        date$.setHours(parseInt(hours))
        date$.setMinutes(parseInt(minutes))
      }
      // console.log('time method date after', JSON.parse(JSON.stringify(date$)))

    },

    removeItem(): void {
      this.$dialog.confirm({
        text: `Удалить пользователя ${this.getData.name}?`,
        title: 'Удаление',
        actions: {
          false: 'Отмена',
          true: {
            color: 'red',
            text: 'Удалить',
            handle: () => {
              this.$emit('remove', this.getData)
            }
          }
        }
      })
    },

    async saveData(): Promise<void> {
      try {
        this.$dialog.confirm({
          text: 'Сохранить изменения?',
          title: 'Сохранение',
          actions: {
            false: 'Отмена',
            true: {
              color: 'green',
              text: 'Сохранить',
              handle: () => {
                this.$emit('update', this.model.obj)
                // this.$emit('update', {
                //   user: this.getData,
                //   data: this.model.obj
                // })
                this.$emit('close')
              }
            }
          }
        })
      } catch (err) {
        this.$errorHandler(err)
      }
    },

    async createData(): Promise<void> {
      try {
        const formRef = this.$refs['user_card_form'] as any
        const v = formRef?.validate() ?? false
        if (!v) return

        this.$dialog.confirm({
          text: 'Добавить нового пользователя?',
          title: 'Добавить нового пользователя',
          actions: {
            false: 'Отмена',
            true: {
              color: 'green',
              text: 'Добавить',
              handle: () => {
                this.$emit('add', this.model.obj)
                this.$emit('close')
              }
            }
          }
        })
      } catch (err) {
        this.$errorHandler(err)
      }
    },

    async resetPass(): Promise<void> {
      console.log(this.$options.name, 'resetPass', 'started', this.getData)
      try {
        const res = await this.$bridge.dropPassword(this.getData.user_id) as { password?: string }
        // const res = await this.$bridge.resetPassword(this.getData.$id) as { password?: string }
        // console.log(this.$options.name, 'resetPass', 'res', res)
        // console.log(this.$options.name, 'resetPass', 'this.$dialog', this.$dialog)
        if (res) {
          navigator.clipboard.writeText(res)
          .then(() => {
            this.$dialog.notify.success(`Новый пароль скопирован в буфер обмена! (${res})`, { timeout: 3000 })
          })
        }
      } catch (err) {
        this.$errorHandler(err)
        console.error('SOMETHING WRONG WITH RESET PASS', err)
      }
    },

    reset(): void {
      this.typeAuth = 'local'
      this.showADFields = false
      this.ADGroups = []
      this.users = []
      this.ADUser = null
      this.ADFilter = {
        cn: null,
        displayName: null,
        mail: null,
        sAMAccountName: null,
      }
      this.meta = null
      this.model = {
        fields: {},
        obj: {
          type_auth: 'local',
          roles: {
            role_enode: null,
            role_nms: null,
          },
          is_blocked: {
            active: false,
            exc: null,
          },
          notification: {
            mail: {
              active: false,
              mail: null
            },
            push: {
              active: false,
            },
            sms: {
              active: false,
              phone: null
            },
          },
        },
        items: {},
        refs: {},
      }
      this.visible = false
      this.ldap = null
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})
</script>

<style lang="stylus" scoped>
.rule
  border 1px solid #c1c163
  margin-bottom: 5px;
  padding: 5px;
.rule-item
  //border 1px solid red
  display flex
  justify-content stretch
  align-items baseline
  .field
    margin 0 3px
    outline: darkgray solid 1px;
    height: 30px;
    padding-left: 5px;
    line-height: 30px;
    background-color: white;
.v-btn.supersmall
  padding-top: 4px
  height: 24px
  width: 24px
  right: 5px
</style>
